import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-terms-condition-modal',
  templateUrl: './terms-condition-modal.component.html',
  styleUrls: ['./terms-condition-modal.component.scss'],
})
export class TermsConditionModalComponent implements OnInit {
  content!: any;
  isAccepted: boolean = false;
  loading: boolean = false;
  userId: string = '';
  constructor(
    private authSvc: AuthService,
    private router: Router,
    private modalSvc: BsModalService,
    private modalRef: BsModalRef
  ) {}

  ngOnInit(): void {
    this.getTerm();
  }

  getTerm() {
    this.loading = true;
    this.authSvc.getTermsAndConditions().subscribe((data) => {
      this.content = data.term;
      this.loading = false;
    });
  }

  submit() {
    this.loading = true;
    this.authSvc.acceptTermAndConditions(this.userId).subscribe(
      (data) => {
        this.loading = false;
        this.router.navigate(['/']);
        this.modalSvc.hide();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  cancel() {
    this.loading = false;
    this.authSvc.logout();
    this.modalSvc.hide();
  }
}
